$(document).ready(function(){
$('.block__section--award-accolades-first-row--').not('.slick-initialized').slick({
    autoplay: !0,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: !1,
    draggable: !1,
    adaptiveHeight: !0,
    speed: 1e4,
    infinite: !0,
    pauseOnHover: !1,
    autoplaySpeed: 0,
    cssEase: "linear",
    vertical: !1,
    verticalSwiping: !1,
    focusOnSelect: !0,
    responsive: [
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }   
  ]
  }); 
$('.block__section--award-accolades-secound-row--').not('.slick-initialized').slick({  
    speed: 1e4,
    autoplay: !0,  
    autoplaySpeed: 0,
    slidesToShow:5,
    slidesToScroll: 1,
    arrows: !1,
    draggable: !1,
    adaptiveHeight: !0,
    infinite: !0,
    pauseOnHover: !1,
    cssEase: "linear",
    vertical: !1,  
    rtl:!1,
    verticalSwiping: !1,
    focusOnSelect: !0,
    responsive: [
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }   
  ]
  }); 
  $('.block__section--award-accolades-third-row--').slick({
    autoplay: !0,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: !1,
    draggable: !1,
    adaptiveHeight: !0,
    speed: 1e4,
    infinite: !0,
    pauseOnHover: !1,
    autoplaySpeed: 0,
    cssEase: "linear",
    vertical: !1,
    verticalSwiping: !1,
    focusOnSelect: !0,
    responsive: [
    {
      breakpoint: 576,
      settings: {
        slidesToShow: 4,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 1
      }
    }   
  ]
  });
  
}); 